<script setup>
import { ref, inject, watch, nextTick } from 'vue';
import Dialog from 'primevue/dialog';

const { infosModele } = defineProps({
    infosModele: Object
});

const texteNomModele = ref(null);
const composantTexte = ref(null);

const affichage = inject('affichageModaleEnregistrerSous');
const enregistrerSous = inject('enregistrerSous');

watch(() => affichage.value, (affichage) => {
    if (affichage) {
        texteNomModele.value = infosModele.nomModele;
        nextTick(() => composantTexte.value.focus());
    }
});

function valider() {
    if (texteNomModele.value.length > 0) {
        enregistrerSous(texteNomModele.value, false);
    }
}

</script>

<template>
    <Dialog v-model:visible="affichage" modal header="Enregistrement du modèle">
        <label class="intitule">Nom du modèle :</label>
		<input type="text" spellcheck="false" v-model="texteNomModele" ref="composantTexte" @keyup.enter="valider()" />
        <template #footer>
            <button 
                class="bouton fas fa-check" 
                :disabled="texteNomModele.length == 0"
                @click="valider()"/>
        </template>
    </Dialog>
</template>

<style scoped>

input {
    margin-top: 2px;
}

</style>